import AdditionalTasksViewModalModule from './view-modal.module'

export default AdditionalTasksViewModalModule
